/*
 * @Description: store
 */
import { createStore, createLogger } from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import { store as user, UserStore, UserState } from '@/store/modules/user/index'
import { store as portal, PortalStore, PortalState } from '@/store/modules/portal/index'
import { store as computer, ComputerStore, ComputerState } from '@/store/modules/computer/index'
import { store as mooc, MoocStore, MoocState } from '@/store/modules/mooc/index'
import { store as dataAnalysis, DataAnalysisStore, DataAnalysisState } from '@/store/modules/dataAnalysis/index'
export interface RootState {
  user: UserState,
  computer: ComputerState,
  mooc: MoocState;
  portal: PortalState;
  dataAnalysis:DataAnalysisState
}

export type Store = UserStore<Pick<RootState, 'user'>>
                  & ComputerStore<Pick<RootState, 'computer'>>
                  & MoocStore<Pick<RootState, 'mooc'>>
                  & PortalStore<Pick<RootState, 'portal'>>
                  & DataAnalysisStore<Pick<RootState, 'dataAnalysis'>>
// Plug in logger when in development environment
const debug = process.env.NODE_ENV !== 'production'
const plugins = debug ? [createLogger({})] : []
// Plug in session storage based persistence
// plugins.push(createPersistedState({ storage: window.sessionStorage }))

export const store = createStore({
  plugins,
  modules: {
    user,
    computer,
    mooc,
    portal,
    dataAnalysis
  }
})

export function useStore(): Store {
  return store as Store
}
